
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 80 80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".92"}},[_c('path',{attrs:{"d":"M65.657 49.008h.014l-.847-1.574-10.831-20.508V14.52h6.65V7.407H19.357v7.114h6.651v12.405l-10.83 20.508-.848 1.567h.014L5.926 64.945v8.182h68.148v-8.182l-8.417-15.937zM33.42 28.514V14.52h13.16v13.993l8.93 16.927c-.292.02-.584.035-.905.035-3.767 0-8.374-4.35-14.605-4.35-6.23 0-10.838 4.35-14.605 4.35-.314 0-.613-.014-.905-.035l8.93-16.927zm-19.775 37.5l7.285-13.816a14.59 14.59 0 003.34.4c6.166 0 10.567-4.352 15.73-4.352s9.563 4.351 15.73 4.351c1.168 0 2.272-.142 3.34-.399l7.285 13.815h-52.71z","fill":"#fff"}}),_c('path',{attrs:{"d":"M5.926 73.134h68.148v-8.182L54 26.926V7.407h-7.42v21.114l19.775 37.5h-52.71l19.775-37.5V7.407H26v19.519L5.926 64.952v8.182z","fill":"#0037FF"}}),_c('path',{attrs:{"d":"M24.03 52.953c6.166 0 10.567-4.35 15.73-4.35 5.162 0 9.563 4.35 15.73 4.35 3.717 0 6.829-1.331 9.94-3.596l-3.467-6.423c-2.777 2.023-4.543 2.898-7.605 2.898-3.767 0-8.375-4.35-14.605-4.35-6.231 0-10.839 4.35-14.606 4.35-3.062 0-4.828-.883-7.605-2.898l-3.468 6.423c3.112 2.265 6.224 3.596 9.941 3.596h.014zM60.547 7.407H19.259v7.114h41.288V7.407z","fill":"#FF4F33"}})])])
          )
        }
      }
    